import { Claim } from '@/domain/pio/Claim'
import { LossDocumentUnsaved, Subcoverage } from '@/domain/pio/Loss'
import { PolicyV2, PetV2 } from '@/domain/pio/Policy'

// Define the steps in the FNOL process
export enum FnolStep {
  FIND_POLICY = 'find-policy',
  SELECT_PET = 'select-pet',
  EXISTING_CLAIMS = 'existing-claims',
  CLAIM_TYPE = 'claim-type',
  CLAIM_DETAILS = 'claim-details',
  REVIEW = 'review',
  CONFIRMATION = 'confirmation',
}

// Claim types
export enum ClaimType {
  ACCIDENT = 'accident',
  ILLNESS = 'illness',
}

export type ClaimCondition = {
  algoliaID: string
  conditionType: string
  conditionId: string
  conditionName: string
  section?: string
}

export interface ClaimConditionWithAccident extends ClaimCondition {
  accident: 'Yes' | 'No' | ''
}

// Data types for each form step
export interface FindPolicyData {
  searchType: string
  policyNumber?: string
  email?: string
  postcode: string
  postcodeMismatch: boolean
}

export interface SelectPetData {
  pet?: PetV2
  policy?: PolicyV2
  potentialPolicies?: PolicyV2[]
}

export interface ExistingClaimsData {
  existingClaims?: Claim[]
  hasDuplicates?: boolean
  claimForContinuation?: Claim
}

export interface ClaimTypeData {
  type?: ClaimType
}

// Do we need to set up a separate interface for each claim type?
export interface ClaimDetailsData {
  claimAmount?: number
  subcoverages: Subcoverage[]
  conditionName: string
  condition: ClaimConditionWithAccident
  payee: 'Your practice' | 'Policy holder'
  referral: 'Yes' | 'No'
  referralPracticeName: string
  referralHistory: any[]
  requiredDocuments: {
    uploadInvoice: any[]
    uploadTreatmentHistory: any[]
    uploadSupportingDocs: any[]
  }
  adviceNote: string
  vetClaimRef: string
}

export interface ReviewData {
  agreedToTerms: boolean
  claim?: Claim
}

export interface FnolState {
  steps: FnolStep[]
  currentStep: FnolStep
  treatmentStartDate: string
  treatmentEndDate: string
  policies: PolicyV2[]
  activePolicies: PolicyV2[]
  findPolicy: FindPolicyData
  selectPet: SelectPetData
  existingClaims: ExistingClaimsData
  claimType: ClaimTypeData
  claimDetails: ClaimDetailsData
  documents: LossDocumentUnsaved[]
  review: ReviewData
}
